import { ServerFilterClauses } from '~commonInfra/utils/ServerFilterClauses';
import { Messages } from '~src/codegen/Localize';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { ContentTypeFilterClause,ExplorableItemDefinition, SpaceDefinition } from '~src/spacesPlatform/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { getNoDefaultFilters } from '~src/spacesPlatform/contentDefinitions/getDefaultFilters';
import { GroupContentType } from '~src/spacesPlatform/models/ContentTypes';

import { ConnectedApplications } from '../resources/ConnectedApplicationsResource';


export const ConnectedApplicationDefinition: ExplorableItemDefinition & SpaceDefinition<'connectedApplication'>  = {
  headerIconPath: () => '', // No page should be making use of this
  contentType: 'connectedApplication',
  itemType: 'connectedApplication',
  singularName: () => Messages.connectedApplication(),
  pluralName: () => Messages.connectedApplications(),
  emptyStateMessage: () => Messages.connectedApplicationsEmptyMessage(),
  contentSpaceUrl: (urls: SpacesSiteUrls, id: string) => urls.connectedApplicationUrl(id), // we don't use this because we have two subspaces - the logic to pick
  // the right content space is in ListViewGridColumnGenerator
  contentFilterKeys: GroupContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconType: null, // No page should be making use of this
  filterClause: ServerFilterClauses.ContentType(['connectedApplication']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return ConnectedApplications.all();
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
